export default (function (layout) {
  var left = layout.left,
      top = layout.top,
      width = layout.width;
  var r = width / 2;
  return {
    x: left + r,
    y: top + r,
    r: r
  };
});